import { ColumnsType } from 'antd/es/table';
import { TFunction } from 'react-i18next';
import { IFeed } from '@/models/feeds.model';
import { formatDate } from '@/utils';
import { getCategoriesRow, getRegionsRow } from '../../helpers';
import TableActions from '../TableActions/TableActions';
import { SupportedLocales } from '@/models/localization.model';

type TGetTableColumns = {
  t: TFunction;
  onDelete: (item: IFeed) => void;
  onEdit: (item: IFeed) => void;
  canManage: boolean;
};

export const getFeedsTableColumns = ({ t, onDelete, onEdit, canManage }: TGetTableColumns): ColumnsType<IFeed> => [
  {
    title: t('feeds_list_name'),
    dataIndex: 'name',
    key: 'name',
    render: (name) => <span>{name}</span>,
  },
  {
    title: t('feeds_filter_type'),
    dataIndex: 'type',
    key: 'type',
    render: (type) => <span>{type?.toUpperCase()}</span>,
    width: 100,
  },
  {
    title: t('feeds_list_region'),
    dataIndex: 'region',
    key: 'region',
    render: (_, record) => <span>{getRegionsRow(record)}</span>,
  },
  {
    title: t('feeds_list_categories'),
    dataIndex: 'categories',
    key: 'categories',
    render: (_, record) => (
      <span>{record.all_categories ? t('feeds_all_categories_label') : getCategoriesRow(record)}</span>
    ),
  },
  {
    title: t('feeds_list_amount'),
    dataIndex: 'products_cnt',
    key: 'products_cnt',
    render: (products_cnt) => <span>{products_cnt?.[SupportedLocales.UK] ?? '0'}</span>,
  },
  {
    title: t('feeds_list_generation_date'),
    dataIndex: 'generation_date',
    key: 'generation_date',
    render: (generation_date) => <span>{generation_date ? formatDate(generation_date) : '-'}</span>,
  },
  {
    title: t('feeds_list_creation_date'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (created_at) => <span>{created_at ? formatDate(created_at) : '-'}</span>,
  },
  {
    title: t('feeds_list_update_date'),
    dataIndex: 'updated_at',
    key: 'updated_at',
    render: (updated_at) => <span>{updated_at ? formatDate(updated_at) : '-'}</span>,
  },
  {
    title: t('feeds_list_status'),
    dataIndex: 'active',
    key: 'active',
    render: (active) => <span>{active ? t('feeds_active') : t('feeds_disabled')}</span>,
  },
  {
    title: t('feeds_list_generation_status'),
    dataIndex: 'generation_status',
    key: 'generation_status',
    render: (generation_status) => (
      <span>{generation_status ? t(`feeds_list_generation_status_${generation_status}`) : '-'}</span>
    ),
  },
  ...(canManage
    ? [
        {
          title: t('feeds_list_actions'),
          key: 'actions',
          render: (_: unknown, record: IFeed) => <TableActions record={record} onEdit={onEdit} onDelete={onDelete} />,
        },
      ]
    : []),
];
